export default __webpack_public_path__ + "static/media/our-story.c1f54b20.png";